import React, { useState, useEffect, Fragment, useRef, useMemo } from "react";
import ReactDOM from "react-dom";
import useRequireAuth from "../../utils/useRequireAuth";
import {
  useFetchCustomerUseListDataQuery,
  useFetchCommonDataQuery,
  useFetchAllTemplateQuery,
} from "../../utils/customer/customerSelect";
import DatePicker from "react-datepicker";
// import {useFetchTaskGetOrgAccordingQuery} from "../../utils/customer/customerTaskTable"
import { FaArrowRight } from "react-icons/fa6";
import "react-datepicker/dist/react-datepicker.css";
import { saveTasks, hideMessage } from "../../utils/customer/customerTaskSlice";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import OwnerDropDown from "../GlobalFeature/Fields/OwnerDropDown";
import { useLazyFetchPersonInTableQuery, useLazyFetchRandomUserQuery } from "../../utils/customer/customerTable";
import { useFetchCustomerAllTaskPodDataQuery } from "../../utils/customer/customerSelect";
import useCustomFormValidation from "../../hooks/ErrorHandling/useCustomFormValidation";
import { createPortal } from "react-dom";
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TextField,
  Checkbox,
  FormControlLabel,
  Tooltip,
  Box,
  Autocomplete,
  Dialog,
  Modal,
  Fade,
  Backdrop,
  Drawer,
} from "@mui/material";
import { CUSTOMER_EDIT_TASK_DATA } from "../../utils/constants";
import useDebounce from "../GlobalFeature/useDebounce";
import { getCommonDataBasedOnId } from "../store/customer/CustomerSocialAddUpdateFunction";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";

import dayjs from "dayjs";
import CreatePortalHOC from "../GlobalFeature/Fields/CreatePortalHOC";
import TaskFormValidation from "../../hooks/ErrorHandling/TaskFormValidation";
import CustomerEditTaskActivity from "../customer/CustomerEditTaskActivity";
import RecurrenceModal from "../customer/RecurrenceModal";
import { ReactComponent as CalendarIcon } from "../../assets/images/calendarIcon.svg";
import { ReactComponent as CloseModalImg } from "../../assets/images/closeModalImg.svg";
import { ReactComponent as AddIconOnProfile } from "../../assets/images/addIconOnProfile.svg";
import { ReactComponent as HandleNotificationexpandshyrink } from "../../assets/images/handleNotificationexpandshyrink.svg";
import { ReactComponent as AddProfileWithCircle } from "../../assets/images/addProfileWithCircle.svg";
import { ReactComponent as CrossIconAddTaskPodModal } from "../../assets/images/crossIconAddTaskPodModal.svg";
import { ReactComponent as AddTaskCrosIcn } from "../../assets/images/addTaskCrosIcn.svg";
import { ReactComponent as RecurtionIcn } from "../../assets/images/recurtionIcn.svg";
import { ReactComponent as CalendarRefreshIcon } from "../../assets/images/calendarRefreshIcon.svg";
import { ReactComponent as TimerImg } from "../../assets/images/icons/TimerImg.svg";
import { ReactComponent as BackIcon } from "../../assets/images/icons/BackIcon.svg";
import {
  useCreateJobMutation,
  useCreateUpdateProjectMutation,
  useFetchAllTaskPodsQuery,
  useFetchCustomerTaskPodAllCustomerDataQuery,
  useLazyFetchAllProjectsQuery,
  useLazyFetchServiceListQuery,
  useLazyGetProjectTaskEnumQuery,
  useLazyGetTaskTagsQuery,
  usePostTaskTagsMutation,
} from "../../utils/customer/customerTaskTable";
import { ReactComponent as CalendarWithTimeIcon } from "../../assets/images/calendarWithTimeIcon.svg";
import { ReactComponent as LinkIcon } from "../../assets/images/linkIcon.svg";
import { ReactComponent as LocationPinIcon } from "../../assets/images/locationPinIcon.svg";
import { ReactComponent as FedCrossIMG } from "../../assets/images/fedCrossIMG.svg";
import { ReactComponent as AddSubTaskDownArrow } from "../../assets/images/addSubTaskDownArrow.svg";
import { ReactComponent as GreenPlusIcon } from "../../assets/images/greenPlusIcon.svg";
import { ReactComponent as RedDeleteIcon } from "../../assets/images/redDeleteIcon.svg";
import { ReactComponent as DownAngleBracket } from "../../assets/images/downAngleBracket.svg";
import { ReactComponent as DeleteSubTaskIcon } from "../../assets/images/deleteSubTaskIcon.svg";
import { ReactComponent as MenuBar } from "../../assets/images/icons/SideMenu.svg";
import { ReactComponent as NextPage } from "../../assets/images/icons/NextPage.svg";
import { ReactComponent as ReloadIcon } from "../../assets/images/icons/ReloadIcon.svg";
import { ReactComponent as Share } from "../../assets/images/Share.svg";
import { ReactComponent as PlusIcon } from "../../assets/images/icons/PlusIcongrey.svg";
import FirstMessage from "../GlobalFeature/MessageAlert/FirstMessage";
import { pushAlert } from "../../utils/alertSlice";

import FloatingList from "../UniversalComponents/FloatingElement";
import CustomDrawer from "../UniversalComponents/CustomDrawer";
import CustomAccordion from "../UniversalComponents/CustomAccordion";
import ConfirmationDialogBox from "../UniversalComponents/ConfirmationDialogBox";
import { Category } from "@mui/icons-material";

import expandButton from "../../assets/images/ExpandButton.svg";
import { getFormData, getSentenceCase } from "../../utils/utilityFunctions/stringUtility";
import DateTimeCombo from "../Task/DateTimeCombo";
import moment from "moment";
import { hideLoader, showLoader } from "../../utils/loaderSlice";
import { getDatePlusOne } from "../../utils/utilityFunctions/dateUtility";
import LabelComponent from "../UniversalComponents/LabelComponent";
import LinkedDrawer from "./../TaskPod/LinkedDrawer";
import AdvancedFieldElements from "../TaskPod/AdvancedFieldElements";
import ProjectDetails from "../TaskPod/ProjectDetails";
import JobSummary from "../TaskPod/JobSummary";
import DelegationMultiSelect from "../Task/DelegationMultiSelect";
import { SubTaskDrawer } from "./SubTaskDrawer";
import { ChecklistDrawer } from "../TaskPod/ChecklistDrawer";
import AddNewPodModal from "./AddNewPodModal";
import AddViewProjectDrawer from "../TaskPod/AddViewProjectDrawer";
const leadTypeList = ["task", "project"];
const formDisabledStatuses = ["Completed", "Drop", "Cancelled"];

let tags_data = [
  { tag_name: "tag1", colour: "#FF5733" },
  { tag_name: "tag2", colour: "#33FF57" },
  { tag_name: "tag3", colour: "#3357FF" },
  { tag_name: "tag4", colour: "#F3F33F" },
  { tag_name: "tag5", colour: "#FF33A1" },
  { tag_name: "tag6", colour: "#A1FF33" },
  { tag_name: "tag7", colour: "#33A1FF" },
  { tag_name: "tag8", colour: "#FFB533" },
  { tag_name: "tag9", colour: "#33FFB5" },
  { tag_name: "tag10", colour: "#B533FF" },
];
let selected_tags = [];

// const formatDate = (date) => {
//   if (!date) return '';
//   const d = new Date(date);
//   const formattedDate = `${d.getDate().toString().padStart(2, '0')}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getFullYear()}`;
//   return formattedDate;
// };

const roundUpToNearest30Minutes = (date) => {
  const minutes = date.getMinutes();
  const nextInterval = Math.ceil(minutes / 30) * 30;
  date.setMinutes(nextInterval);
  date.setSeconds(0);
  date.setMilliseconds(0);
  return date;
};

const addMinutes = (date, minutes) => {
  const newDate = new Date(date);
  newDate.setMinutes(newDate.getMinutes() + minutes);
  return newDate;
};

// Helper function to check if two dates are on the same day
const isSameDay = (date1, date2) => {
  return date1.toDateString() === date2.toDateString();
};

const colorPool = ["#37C015", "#BE4A25", "#401E87", "#6417D8", "#F16136"];

const AddTaskPodModal = ({
  isOpen,
  closePopup,
  taskid,
  customer_name,
  handelSubmitData,
  taskPod,
  refetch = () => {},
  rowData,
  completeData,
  setAlert,
  alert,
  leadTypeValue,
  disableLeadTypeChange,
  onClose,
  selectedCustomer,
  checkListOpen,
  setCheckListOpen,
  customerTask,
  customerData,
  setLeadTypeValue = () => {},
  openSubTaskDrawer,
  // isDoubleComp = false,
  recurModal,
  activeModal,
  externalApi,
}) => {
  console.log(taskid, "taskid aakash");
  const token = useRequireAuth();

  const completeAuth = useRequireAuth();

  const { id: customerId } = useParams();
  const dispatch = useDispatch();
  const companyLocalData = localStorage.getItem("company_data");
  const userData = localStorage.getItem("myUserData");
  const userId = JSON.parse(userData).user_id;

  const parsedCompanyData = JSON.parse(companyLocalData);
  const [customerTablePagination, setCustomerTablePagination] = useState("");
  const [activeTab, setActiveTab] = useState("#All");
  const [quiFilter, setQuiFilter] = useState("");
  //const[taskOpenTab,getTaskOpenTab]=useState(1)

  const [refreshKey, setRefreshKey] = useState(0);
  const [isOpens, setIsOpens] = useState();
  const [contactName, setContactName] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(isOpen && recurModal);
  const [showTime, setShowTime] = useState(false);
  const [showEndDate, setShowEndDate] = useState(false);
  const [isTagsOpen, setIsTagsOpen] = useState(false);

  const [isSearchBarOpen, setIsSearchBarOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  // const debouncedSearchTerm = useDebounce(searchTerm, 500);
  const [customerSearch, setCustomerSearch] = useState("");

  const taskassignedtoref = useRef(null);
  const [dropdownCoord, setDropdownCoord] = useState(null);

  const isFirstRender = useRef(true);
  const [showSubtaskForm, setShowSubtaskForm] = useState(openSubTaskDrawer);

  const storedData = localStorage.getItem("company_data");
  const companyId = storedData ? JSON.parse(storedData) : null;
  // const [leadType, setLeadType] = useState(leadTypeValue);
  // const [hasFormChanged, setHasFormChanged] = useState(false);
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const [openAddNewPodModal, setOpenAddNewPodModal] = useState(false);
  const [subTaskSelected, setSubtaskSelected] = React.useState({});
  const [openAddProject, setOpenAddProject] = useState(false);
  const [subTaskSerial, setSubTaskSerial] = useState(1);
  const [checklistSerial, setChecklistSerial] = useState(1);
  const [isLinkOpen, setIsLinkOpen] = useState(false);
  const [preSelectedCustomer, setPreSelectedCustomer] = useState({});
  const drawerRef = useRef(null);
  const extractDateAndTime = (isoString) => {
    if (!isoString) {
      return {
        date: null,
        time: null,
      };
    }
    const date = dayjs(isoString);
    return {
      date: date.format("YYYY-MM-DD"),
      time: date.format("HH:mm:ss"),
    };
  };

  const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

  // console.log(isKanban, io,"isKanban cvinay")
  const parseWeeklyDays = (daysString) => {
    if (!daysString) {
      return [];
    }

    try {
      return JSON.parse(daysString);
    } catch (error) {
      return [];
    }
  };

  // const initialWeeklyDays = taskid?.weekly_days ? taskid.weekly_days.split(",") : [daysOfWeek[new Date().getDay()]];

  const initialWeeklyDays = taskid?.weekly_days
    ? parseWeeklyDays(taskid.weekly_days)
    : ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];
  // : [daysOfWeek[new Date().getDay()]];

  const { data: customerTaskPodAllCustomer } = useFetchCustomerTaskPodAllCustomerDataQuery({
    token,
    companyId,
    search: customerSearch,
  });

  const {
    refetch: refetchGetAllTemplate,
    data: GetAlltemplates,
    isLoading: isGetAllTemplatesLoading,
    isError: isGetAllTemplatesError,
    isSuccess: isGetAllTemplatesSuccess,
    error: GetAllTemplatesError,
  } = useFetchAllTemplateQuery();

  console.log(GetAlltemplates, "GetAlltemplates vinya");

  // HANDLE GET ALL TEMPLATES
  useEffect(() => {
    if (isGetAllTemplatesLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }

    if (isGetAllTemplatesSuccess && GetAlltemplates?.success) {
      dispatch(pushAlert({ message: GetAlltemplates.message, type: "success", visible: true }));

      setFormData({ ...formData, category_id: GetAlltemplates?.data[0]?.id || "" });
    } else if (isGetAllTemplatesError) {
      dispatch(
        pushAlert({
          message: GetAllTemplatesError?.data?.message || "Error fetching templates",
          type: "danger",
          visible: true,
        })
      );
    }
  }, [isGetAllTemplatesLoading, isGetAllTemplatesSuccess, isGetAllTemplatesError, GetAlltemplates]);

  const [updateTagsData, { data: taskTagsData, isFetching: isFetchingTaskTags }] = usePostTaskTagsMutation();

  useEffect(() => {
    let existingCustomer = {};
    if (customerId) {
      const filteredItem = customerTaskPodAllCustomer?.data?.customers.find((item) => item.customer_id == customerId);
      existingCustomer = { customer_id: filteredItem?.customer_id, customer_name: filteredItem?.customer_name };
    } else if (selectedCustomer) {
      if (selectedCustomer?.customer_id)
        existingCustomer = {
          customer_id: selectedCustomer?.customer_id,
          customer_name: selectedCustomer?.customer_name,
        };
      else if (selectedCustomer?.id) {
        existingCustomer = { customer_id: selectedCustomer?.id, customer_name: selectedCustomer?.customer_name };
      }
    }

    if (existingCustomer?.customer_id) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        customer_name: existingCustomer?.customer_name || "",
        customer_id: existingCustomer?.customer_id || "",
      }));
    }
  }, [customerTaskPodAllCustomer, selectedCustomer]);

  const {
    data: { data: customerTaskUserList } = {},
    error: customerTaskUserListerror,
    isLoading: customerTaskUserListLoading,
  } = useFetchCustomerUseListDataQuery({
    token: token?.token,
  });

  const default_selected = customerTaskUserList?.filter((item) => item.id == userId);

  const initialFormData = {
    ...taskid,

    id: taskid?.id || "",
    customer_name: taskid?.customer_name ?? "",
    customer_id: taskid?.customer_id ?? "",
    customer_display_name: taskid?.customer_display_name || "",
    remarks: "",
    subject: taskid?.subject || "",
    category_id:
      (taskid?.category_id === "all" ? "task" : taskid?.category_id) ||
      (leadTypeValue === "all" ? "task" : leadTypeValue) ||
      "",
    priority: taskid?.priority || "",
    description: taskid?.description || "",
    status: taskid?.status || "Not started",
    task_pod: taskid?.task_pod,
    //due_date:"",
    start_date:
      taskid?.selection === "entire"
        ? extractDateAndTime(taskid?.recurrence_series_start).date
        : extractDateAndTime(taskid?.start?.value).date,
    end_date:
      taskid?.selection === "entire"
        ? extractDateAndTime(taskid?.recurrence_series_end).date
        : extractDateAndTime(taskid?.end?.value).date,
    selection: taskid?.selection,
    start_time: taskid?.start_time || extractDateAndTime(taskid?.start?.value).time || "",
    end_time: taskid?.end_time || extractDateAndTime(taskid?.end?.value).time || "",
    assigned_to: taskid?.assigned_to || default_selected || [],
    is_recurrence: taskid?.is_recurrence || "",
    recurrence_pattern_id: taskid?.recurrence_pattern_id || "",
    radioselected: "",
    every_weekday: "",
    after_occur: "",
    modifiedspecific: "",

    frequency: taskid?.frequency || "daily",
    intervals: taskid?.intervals || 1,
    every_weeks: "",
    daily_recur: "",
    monthly_recur: "",
    yearly_recur: "",
    occurrences: "",
    daily_option: taskid?.daily_option || "every_n_days",
    weekly_days: initialWeeklyDays,
    endBy: "end_by",
    monthly_option: taskid?.monthly_option || "specific_day",
    monthly_week: taskid?.monthly_week || "first",
    day_of_week: taskid?.day_of_week,
    day_of_month: taskid?.day_of_month,
    yearly_option: taskid?.yearly_option || "specific_year",
    sub_tasks: taskid?.sub_tasks || [],
    checklists: taskid?.checklists || [],
    // category_id: taskid?.category_id || leadTypeValue || "",
  };

  // if (taskid?.selection === "specific") {
  //   initialFormData.update_single_occurrence = 1;
  // } else {
  //   initialFormData.update_entire_series = 1;
  // }

  const [formData, setFormData] = useState(initialFormData || {});

  useEffect(() => {
    if (!taskid?.assigned_to) {
      setFormData((prevData) => ({
        ...prevData,
        assigned_to: default_selected || [],
      }));
    }
  }, [customerTaskUserList]);
  console.log(formData?.assigned_to, "assigned_to aakash");

  // console.log(default_selected, "default_selected");

  const initialSubTaskForm = {
    start_date: formData?.start_date,
    assigned_to: [default_selected?.[0]],
    task_type: "new",
    serial: subTaskSerial,
    status: "Not Started",
  };

  const [subTaskForm, setSubTaskForm] = useState(initialSubTaskForm);

  const initialChecklistForm = {
    name: "",
    status: "Not Started",
    checklist_type: "new",
    serial: checklistSerial,
    delegation: [],
  };
  const [checklistForm, setChecklistForm] = useState(initialChecklistForm);

  useEffect(() => {
    setSubTaskForm(initialSubTaskForm);
  }, [formData?.start_date, subTaskSerial]);

  useEffect(() => {
    setChecklistForm(initialChecklistForm);
  }, [checklistSerial]);

  const subTaskContainerRef = useRef(null);
  const prevSubTasksRef = useRef(formData.sub_tasks);

  // const handleMouseEnter = () => {
  //   setIsSearchBarOpen(!isSearchBarOpen);
  //   fetchPersonData("");

  // };

  const [fetchPersonInTable, { data: personTableData }] = useLazyFetchPersonInTableQuery();

  const [fetchAllProjects, { data: projectsAllData, isFetching: projectsAllDataLoading }] =
    useLazyFetchAllProjectsQuery();
  const [createProjectJob, { data: projectJobData, isFetching: isProjectJobCreating }] = useCreateJobMutation();
  const [fetchFieldValues, { data: projectFieldList, isFetching: projectFieldListLoading }] =
    useLazyGetProjectTaskEnumQuery();
  const [fetchServiceList, { data: serviceList, isFetching: serviceListLoading }] = useLazyFetchServiceListQuery();
  const { data: customerCommonData, error, isLoading: commonDataLoading } = useFetchCommonDataQuery();
  const [fetchTaskTags, { data: TaskTagsList, isFetching: isTaskTagsLoading }] = useLazyGetTaskTagsQuery();

  useEffect(() => {
    fetchTaskTags("", false);
  }, []);
  useEffect(() => {
    if (isProjectJobCreating) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [isProjectJobCreating, commonDataLoading]);

  const CustomerSearchChange = (event, newInputValue) => {
    setCustomerSearch(newInputValue);
  };

  const handleCustomerChange = (event, newValue) => {
    if (newValue) {
      setFormData({
        ...formData,
        customer_name: newValue.customer_name,
        customer_id: newValue.customer_id,
      });
    } else {
      setFormData({
        ...formData,
        customer_name: "",
        customer_id: "",
      });
    }
  };

  const fetchPersonData = (data) => {
    fetchPersonInTable({ token: token?.token, data: data, companyId: companyId?.company_id });
  };

  const fetchAllProjectsCall = () => {
    fetchAllProjects({ customerId: formData?.customer_id });
  };

  const handleMouseEnter = (index) => {
    setIsSearchBarOpen((prevState) => ({
      ...prevState,
      [index]: true,
    }));
    setDropdownCoord((prevState) => {
      return getCreatePortalPosition();
    });
    fetchPersonData("");
  };

  useEffect(() => {
    if (checkListOpen) {
      setShowSubtaskForm("project");
    }
  }, [checkListOpen]);

  const handleMouseLeave = (index) => {
    setIsSearchBarOpen((prevState) => ({
      ...prevState,
      [index]: false,
    }));
    setDropdownCoord(null);
  };

  const openPopup = () => {
    setIsPopupOpen((prev) => !prev);
    setShowNotification(false);
    setShowSubtaskForm(false);
  };
  const closePopupRecur = () => {
    setIsPopupOpen(false);
  };

  // const [formData, setFormData] = useState({
  //   id:  taskid?.id || "",
  //   subject: taskid?.subject || "",
  //   category_id: taskid?.category_id || "",
  //   priority: taskid?.priority || "",
  //   description: taskid?.description || "",
  //   status: taskid?.status || "",
  //   // due_date: taskid?.due_date || "",
  //   task_pod: taskid?.task_pod || "",
  //   start_date: taskid?.start_date || taskid?.start?.value || "",
  //   end_date: taskid?.end_date || taskid?.end?.value || "",
  //   start_time:  taskid?.start_time  || "",
  //   end_time:  taskid?.end_time || "",
  //   assigned_to: taskid?.assigned_to || "",
  //   is_recurrence:  taskid?.is_recurrence || "",
  //   recurrence_pattern_id:  taskid?.recurrence_pattern_id || "",
  //   radioselected:  "",
  //   every_weekday:  "",
  //   after_occur:  "",
  //   modifiedspecific: taskid?.update_entire_series === 0,

  // });

  const getRoundedTime = () => {
    const now = new Date();

    // Add 30 minutes to the current time
    now.setMinutes(now.getMinutes() + 30);

    // Round the minutes to the nearest 30-minute interval
    const minutes = now.getMinutes();
    const roundedMinutes = minutes < 30 ? 0 : 30;

    now.setMinutes(roundedMinutes);
    now.setSeconds(0, 0); // Clear seconds and milliseconds

    // Format hours and minutes to match the dropdown format (e.g., 6:00, 6:30)
    const hours = now.getHours() % 12 || 12; // Convert to 12-hour format
    const formattedTime = `${hours}:${roundedMinutes === 0 ? "00" : "30"}`;

    return formattedTime;
  };

  useEffect(() => {
    if (formData?.selection === "specific" || formData?.is_recurrence === 0) {
      setFormData((prevData) => ({
        ...prevData,
        update_single_occurrence: 1,
        update_entire_series: 0,
      }));
    } else if (formData?.selection === "entire" || formData?.is_recurrence === 1) {
      setFormData((prevData) => ({
        ...prevData,
        update_single_occurrence: 0,
        update_entire_series: 1,
      }));
    }
  }, [formData.selection, formData.is_recurrence]);

  // useEffect(() => {
  //   if (subTaskContainerRef.current) {
  //     // Scroll to the bottom of the task container
  //     subTaskContainerRef.current.scrollTop = subTaskContainerRef.current.scrollHeight;
  //   }
  // }, [formData.sub_tasks]);

  useEffect(() => {
    if (subTaskContainerRef.current) {
      // Compare previous and current subtask length to detect addition
      if (formData.sub_tasks?.length > prevSubTasksRef.current?.length) {
        // Scroll to the bottom if a new subtask was added
        subTaskContainerRef.current.scrollTop = subTaskContainerRef.current.scrollHeight;
      }

      // Update the reference to the current subtask list
      prevSubTasksRef.current = formData.sub_tasks;
    }
  }, [formData.sub_tasks]);

  const [defaultFormData, setDefaultFormData] = useState(initialFormData);

  const [startDate, setStartDate] = useState(
    // taskid?.start_date ? new Date(taskid?.start_date) :
    formData?.start_date ? new Date(formData.start_date) : new Date()
  );

  const cross = true;

  const [endDate, setEndDate] = useState(
    // taskid?.end_date ? new Date(taskid?.end_date) :
    formData?.end_date ? new Date(formData?.end_date) : new Date()
  );
  const [showNotification, setShowNotification] = useState(activeModal ? true : false);
  const handleNotification = () => {
    setShowNotification(!showNotification);
  };

  const addSubtask = () => {
    if (!subTaskForm?.subject?.trim() || subTaskForm.assigned_to.length === 0) {
      dispatch(pushAlert({ message: "Enter Mandatory Fields.", type: "danger", visible: true }));
      return;
    }
    setShowSubtaskForm(formData?.category_id?.toLowerCase());
    if (subTaskForm?.task_type === "new") {
      setSubTaskSerial((prevSerial) => prevSerial + 1);
    } else {
      setSubTaskForm(initialSubTaskForm);
    }
    if (!isFormDisabled) {
      setFormData((prevData) => {
        const exists = prevData.sub_tasks.some((eachSubTask) =>
          subTaskForm?.task_type === "new"
            ? eachSubTask?.serial === subTaskForm?.serial
            : eachSubTask.id === subTaskForm.id
        );
        return {
          ...prevData,
          sub_tasks: exists
            ? prevData?.sub_tasks?.map((eachSubTask) =>
                (
                  subTaskForm?.task_type === "new"
                    ? eachSubTask?.serial === subTaskForm?.serial
                    : eachSubTask.id === subTaskForm.id
                )
                  ? subTaskForm
                  : eachSubTask
              )
            : [...prevData.sub_tasks, subTaskForm],
        };
      });
    }
  };

  const addChecklist = () => {
    if (!checklistForm?.fs_item?.trim() || checklistForm?.delegation?.length === 0) {
      dispatch(pushAlert({ message: "Enter Mandatory Fields.", type: "danger", visible: true }));
      return;
    }
    setShowSubtaskForm(formData?.category_id?.toLowerCase());
    if (checklistForm?.checklist_type === "new") {
      setChecklistSerial((prevSerial) => prevSerial + 1);
    } else {
      setChecklistForm(initialChecklistForm);
    }
    if (!isFormDisabled) {
      setFormData((prevData) => {
        const exists = prevData.checklists.some((eachChecklist) =>
          checklistForm?.checklist_type === "new"
            ? eachChecklist?.serial === checklistForm?.serial
            : eachChecklist.id === checklistForm.id
        );
        return {
          ...prevData,
          checklists: exists
            ? prevData?.checklists?.map((eachChecklist) =>
                (
                  checklistForm?.checklist_type === "new"
                    ? eachChecklist?.serial === checklistForm?.serial
                    : eachChecklist.id === checklistForm.id
                )
                  ? checklistForm
                  : eachChecklist
              )
            : [...prevData.checklists, checklistForm],
        };
      });
    }
  };

  // const [formData, setFormData] = useState({
  //   subject: "",
  //   category_id: "",
  //   priority: "",
  //   description: "",
  //   contact_name: "",
  //   status: "",
  //   due_date: "",
  //   task_pod: "",
  //   start_date: "",
  //   end_date: "",
  //   owner: "",
  //   is_recurrence: "",
  // });

  const handleCheck = (index, event) => {
    setSearchTerm((prevState) => ({
      ...prevState,
      [index]: event.target.value,
    }));
  };

  const handleDeleteSubtask = (listOfIndex, type, isNew) => {
    const updatedSubtasks = formData?.[type === "checklist" ? "checklists" : "sub_tasks"].filter(
      (eachSubTask) => !Boolean(listOfIndex.includes(isNew ? eachSubTask?.serial : eachSubTask?.id))
    );
    setFormData((prevFormData) => ({
      ...prevFormData,
      [type === "checklist" ? "checklists" : "sub_tasks"]: updatedSubtasks,
    }));
  };

  const handleRemoveNoSubjectSubTask = () => {
    const updatedSubtasks = formData.sub_tasks.filter((eachSubTask, i) => eachSubTask.subject !== "");
    setFormData((prevFormData) => ({ ...prevFormData, sub_tasks: updatedSubtasks }));
  };

  // Function to handle changes in subtask fields
  // const handleSubtaskChange = (index, e) => {
  //   const { name, value } = e.target;
  //   const updatedSubtasks = [...formData.sub_tasks];
  //   updatedSubtasks[index] = { ...updatedSubtasks[index], [name]: value };
  //   setFormData(prevData => ({
  //     ...prevData,
  //     sub_tasks: updatedSubtasks,
  //   }));
  // };

  const handleSubtaskChange = (index, e) => {
    const { name, type, value, checked } = e.target;

    // Determine the correct value to use
    const inputValue = type === "checkbox" ? checked : value;

    const updatedSubtasks = [...formData?.sub_tasks];
    updatedSubtasks[index] = { ...updatedSubtasks[index], [name]: inputValue };

    setFormData((prevData) => ({
      ...prevData,
      sub_tasks: updatedSubtasks,
    }));
  };

  const handleChecklistChange = (index, e) => {
    const { name, type, value, checked } = e.target;

    // Determine the correct value to use
    const inputValue = type === "checkbox" ? checked : value;

    const updatedSubtasks = [...formData?.checklists];
    updatedSubtasks[index] = { ...updatedSubtasks[index], [name]: inputValue };

    setFormData((prevData) => ({
      ...prevData,
      checklists: updatedSubtasks,
    }));
  };

  const ActivateRecur = (recurrdata) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      ...recurrdata,
    }));
    closePopupRecur();
  };

  // useEffect(() => {
  //   if (startDate) {
  //     let combinedDate = startDate.toLocaleDateString('en-GB');

  //     if (endDate && startDate.getTime() !== endDate.getTime()) {
  //       combinedDate += ` - ${endDate.toLocaleDateString('en-GB')}`;
  //     }

  //     setFormData(prevFormData => ({
  //       ...prevFormData,
  //       due_date: combinedDate,
  //     }));
  //   }
  // }, [startDate, endDate]);
  useEffect(() => {
    setFormData((prevState) => ({
      ...prevState,
      start_date: startDate ? startDate.toISOString() : "",
      end_date: endDate ? endDate.toISOString() : "",
    }));

    console.log(formData?.start_date, "startDate.toISOString() aakash");
    // setDefaultFormData(prevState => ({
    //   ...prevState,
    //   start_date: startDate ? startDate.toISOString() : "",
    //   end_date: endDate ? endDate.toISOString() : "",
    // }));

    //commenting this, because it was setting the lead type back to task, and was creating some problem, don't
    //know why was this written initially
    // return () => {
    //   setLeadTypeValue("task");
    // };
  }, [startDate, endDate]);

  const validationRules = useMemo(
    () => ({
      customer_id: {
        required: true,
        errorMessage: "Customer Name is Required.",
        compulsory: true,
      },
      subject: {
        required: true,
        errorMessage: "Subject is required.",
        compulsory: true,
      },
      assigned_to: {
        required: true,
        errorMessage: "task must be assigned.",
        compulsory: true,
      },
      sub_tasks: {
        required: true,
        errorMessage: "sub_tasks ",
        // compulsory: category_id?.toLowerCase()==="task",
      },
      project_id: {
        required: true,
        errorMessage: "Project Name is required.",
        compulsory: formData?.category_id?.toLowerCase() === "project",
      },
      service_id: {
        required: true,
        errorMessage: "Service Type is required",
        compulsory: formData?.category_id?.toLowerCase() === "project",
      },
      start_date: {
        required: true,
        errorMessage: "Job Start Date is required.",
        compulsory: formData?.category_id?.toLowerCase() === "project",
      },
      end_date: {
        required: true,
        errorMessage: "Job Start End is required.",
        compulsory: formData?.category_id?.toLowerCase() === "project",
      },
      category_id: {
        required: true,
        errorMessage: "Category is required.",
        compulsory: true,
      },
      // due_date: {
      //   required: true,
      //   errorMessage: 'Due is required.',
      // }
    }),
    [formData?.category_id]
  );
  const { errors, isFormValid } = TaskFormValidation(formData, validationRules);

  const getHasError = (errors) => {
    let hasErrors = false;
    if (typeof errors?.subject !== "undefined" || typeof errors?.assigned_to !== "undefined") {
      hasErrors = true;
    }

    if (errors?.sub_tasks?.subject && errors?.sub_tasks?.subject.length > 0) {
      errors?.sub_tasks?.subject.forEach((task) => {
        if (task?.value !== "subjectFound") {
          hasErrors = true;
        }
      });
    }

    if (errors?.sub_tasks?.assigned_to && errors?.sub_tasks?.assigned_to.length > 0) {
      errors.sub_tasks.assigned_to.forEach((task) => {
        if (task?.value !== "assignedToFound") {
          hasErrors = true;
        }
      });
    }

    const hasEmptySubtaskSubject = formData?.sub_tasks?.some((subtask) => subtask?.subject === "");
    if (hasEmptySubtaskSubject) {
      hasErrors = true;
    }
    const hasEmptyChecklistSubject = formData?.checklists?.some((subtask) => subtask?.fs_item === "");
    if (hasEmptyChecklistSubject) {
      hasErrors = true;
    }
    hasErrors = Object.keys(validationRules).some(
      (eachKey) => validationRules[eachKey]?.compulsory && errors[eachKey]?.[0]
    );

    return hasErrors;
  };

  const [showRemark, setShowRemark] = useState(false);

  // const [categoryChange, setCategoryChange] = useState({});
  const [category, setCategory] = useState({ name: "category_id", value: leadTypeValue });

  const [taskPods, setTaskPods] = useState([]);
  const handleInputChange = (event) => {
    // event.preventDefault();
    const { name, value } = event.target;

    if ((name === "target_delivery_date" || name === "billing_date") && value == "Invalid date") {
      return;
    }
    if (name === "start_time") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        end_time: roundUpToNextHalfHour(value),
      }));

      console.log(formData?.start_time, "formData?.start_time aakash");
    }

    // Handle showing remark based on category_id value (for example, if it's 17)
    if (value === "17") {
      setShowRemark(true);
    } else {
      setShowRemark(false);
    }
    if (name === "task_pod") {
      if (value === "addNew") {
        setOpenAddNewPodModal(true);
        setFormData((prevFormData) => ({ ...prevFormData, task_pod: "" }));

        return;
      }
    }

    // Handle showing/hiding "Opens" based on category_id value
    // if (name === "category_id") {
    //   if (value === "Task") {
    //     setIsOpens(true);
    //   } else {
    //     setIsOpens(false);
    //   }
    //   setRefreshKey((prevKey) => prevKey + 1);
    // }

    // Handle the status change for the main task and update subtasks
    if (name === "status") {
      // Update the main task status
      setFormData((prevFormData) => {
        const newStatus = value;

        // Update subtasks based on the new main task status
        const updatedSubTasks = taskid?.sub_tasks?.map((subtask) => {
          // Update subtask status if not already one of the selected statuses
          if (
            newStatus === "Completed" &&
            subtask.status !== "Completed" &&
            subtask.status !== "Drop" &&
            subtask.status !== "Cancelled"
          ) {
            return { ...subtask, status: "Completed" };
          } else if (
            newStatus === "Drop" &&
            subtask.status !== "Completed" &&
            subtask.status !== "Drop" &&
            subtask.status !== "Cancelled"
          ) {
            return { ...subtask, status: "Drop" };
          } else if (
            newStatus === "Cancelled" &&
            subtask.status !== "Completed" &&
            subtask.status !== "Drop" &&
            subtask.status !== "Cancelled"
          ) {
            return { ...subtask, status: "Cancelled" };
          }
          return subtask;
        });

        return {
          ...prevFormData,
          status: newStatus, // Update the main task status
          sub_tasks: updatedSubTasks || [], // Update the subtasks
        };
      });
    }

    if (name === "category_id") {
      if (formData?.category_id?.toLowerCase() === "project" && value?.toLowerCase() !== "project") {
        setCategory({ name: "category_id", value: value });
        setOpenConfirmationDialog("discard_project_and_switch_to_other_task");
      } else if (
        formData?.category_id?.toLowerCase() === "task" &&
        value?.toLowerCase() !== "task" &&
        formData["sub_tasks"]?.length
      ) {
        setCategory({ name: "category_id", value: value });
        setOpenConfirmationDialog("discard_subtask_and_switch_to_non-task");
      } else {
        setLeadTypeValue(value);
        setFormData((prevFormData) => ({
          ...prevFormData,
          [name]: value,
        }));
      }
    } else {
      setFormData((prevFormData) => {
        return {
          ...prevFormData,
          [name]: value,
        };
      });
    }

    setShowNotification(false);
    // setShowSubtaskForm("");
    setIsPopupOpen(false);
  };

  const handleCategoryUpdate = () => {
    const { name, value } = category || {};
    setLeadTypeValue(value);
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
      ...(value?.toLowerCase() === "task" && { assigned_to: prevFormData.assigned_to.slice(0, 1) }),
      sub_tasks: [],
    }));

    // setCategory();
  };

  const [dueDate, setDueDate] = useState();
  //const { data: taskRecurrenceAll, refetch: taskRecurrenceFetch } = useFetchTaskGetOrgAccordingQuery({ token });
  const fetchTaskEditData = async (taskid) => {
    const url = `${CUSTOMER_EDIT_TASK_DATA}${taskid}`;
    const getData = await getCommonDataBasedOnId(url, token?.token);

    setFormData((prevFormData) => ({
      ...prevFormData,
      ...Object.keys(getData[0]).reduce((acc, key) => {
        if (getData[0][key] !== null && getData[0][key] !== undefined) {
          acc[key] = getData[0][key];
        }
        return acc;
      }, {}),
    }));
    //setFormData(getData[0]);
    setDueDate(getData[0]?.due_date);
    if (getData[0]?.category_id === "task") {
      setIsOpens(true);
    }
  };

  // useEffect(() => {
  //   if(isEditTask){
  //   fetchTaskEditData(taskid);
  // }}, [taskid]);

  const handleInputDateChange = (value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      due_date: new Date(value?.due_date),
    }));
  };

  //   useEffect(() => {
  //     const normalizeValues = (obj) => {
  //       return Object.fromEntries(
  //           Object.entries(obj).map(([key, value]) => [key, value === null ? "" : value])
  //       );
  //   };

  //   const isFormChanged = JSON.stringify(normalizeValues(formData)) !== JSON.stringify(normalizeValues(initialFormData));
  //   setHasFormChanged(isFormChanged)
  // }, [formData]);

  // useEffect(() => {
  //   const listOfEntries = ["customer_id", "subject"];
  //   const isFormChangedFlag = listOfEntries.some((key) => formData[key] !== initialFormData[key]);
  //   setHasFormChanged({
  //     isFormChanged: isFormChangedFlag,
  //     isSubtaskChanged: JSON.stringify(formData?.sub_tasks) !== JSON.stringify(initialFormData?.sub_tasks),
  //   });
  // }, [formData]);

  const handleRemoveSubtasks = () => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      sub_tasks: [],
    }));
  };

  const handleRemoveChecklist = () => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      checklists: [],
    }));
  };
  // useEffect(() => {
  //   if (leadType?.toLowerCase() === "project") {
  //     setOpenConfirmationDialog(leadType === "project" && formData?.sub_tasks?.some((subtask) => subtask.subject));
  //   }

  // }, [leadType]);

  const checkFormChanged = () => {
    return Object.keys(formData).some((key) => formData[key] !== defaultFormData[key]);
  };

  const handleSubmitTask = async (event) => {
    event.preventDefault();
    const formValid = isFormValid();
    const a = getHasError(formValid);

    if (a) {
      dispatch(pushAlert({ message: "Enter Mandatory Fields.", type: "danger", visible: true }));
      return;
    }

    dispatch(showLoader());
    const formChanged = checkFormChanged();
    const modifiedspecific = formChanged && formData?.update_single_occurrence;
    const taskDatas = {
      ...formData,
      priority: formData.priority || event?.target?.priority?.value,
      status: formData?.status,
      category_id: formData.category_id || event?.target?.category_id?.value,
      task_pod: formData.task_pod || event?.target?.task_pod?.value,
      customer_id: formData.customer_id,
      // due_date:"random due date",
      // due_date:formData?.due_date,
      company_id: parsedCompanyData.company_id,
      start_date: formData?.start_date?.toLocaleString("en-GB", { hour12: false }),
      end_date: formData?.end_date?.toLocaleString("en-GB", { hour12: false }),
      modifiedspecific: modifiedspecific,
      billing_details: [projectFields4?.reduce((acc, field) => ({ ...acc, [field.name]: formData[field.name] }), {})],
    };

    if (externalApi) {
      externalApi?.createUpdateTask(taskDatas);
    } else {
      const response = await createProjectJob({ payload: getFormData(taskDatas) || {} }).unwrap();
      if (response?.status) {
        dispatch(pushAlert({ message: response?.message, type: "success", visible: true }));
        refetch();
      } else {
        dispatch(pushAlert({ message: response?.message, type: "danger", visible: true }));
      }
    }
    // try {

    dispatch(hideLoader());
    closePopup();
  };

  useEffect(() => {
    if (!taskid) return;

    if (taskid.end_date) {
      setShowEndDate(true);
    }

    if (taskid?.start_time || taskid?.end_time || extractDateAndTime(taskid?.start?.value)?.time !== "00:00:00") {
      setShowTime(true);
    }
  }, [taskid]);

  useEffect(() => {
    if (customerTaskUserList) {
      const default_selected = customerTaskUserList?.filter((item) => item.id == userId);
      setFormData((prevFormData) => {
        const alreadyExists = prevFormData.assigned_to.some(
          (item) => item.id === default_selected[0].id // Assuming objects have an 'id' field for uniqueness
        );

        if (alreadyExists || taskid) {
          return prevFormData; // Return the previous state without changes
        }

        return {
          ...prevFormData,
          assigned_to: [...prevFormData.assigned_to, default_selected[0]],
        };
      });

      setSubTaskForm((prevFormData) => ({
        ...prevFormData,
        assigned_to: [default_selected?.[0]],
      }));

      setChecklistForm((prevFormData) => ({
        ...prevFormData,
        delegation: [default_selected?.[0]],
      }));
    }
  }, [customerTaskUserList, subTaskSerial, checklistSerial]);

  const handleInsert = (item) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      assigned_to: [...prevFormData.assigned_to, item],
    }));
  };

  const tableDetail = {
    tableidclass: "taskmodelowner",
  };

  const handlePersonData = (value) => {
    setContactName(value.name);
  };

  // const { data: customerTaskPodList } = useFetchCustomerAllTaskPodDataQuery({
  //   token: token?.token,
  //   company: parsedCompanyData,
  // });

  const getUniversalTaskType = (value) => {
    if (value) {
      if (formData?.category_id === "project") {
        return "project";
      } else {
        return "task";
      }
    }
    return "";
  };
  const { data: newTaskpodsAll, refetch: refetchAllTaskpods } = useFetchAllTaskPodsQuery({
    token: token?.token,
    type: getUniversalTaskType(formData?.category_id),
    customerId: formData?.customer_id ?? "",
    companyId: parsedCompanyData?.company_id,
  });

  useEffect(() => {
    if (newTaskpodsAll) {
      setTaskPods(newTaskpodsAll);
    }
  }, [newTaskpodsAll]);

  const StartDateChange = (date) => {
    setStartDate(date);
    // const nextDay = new Date(date);
    // nextDay.setDate(nextDay.getDate());
    setEndDate(date);
  };

  const generateTimeOptions = () => {
    const times = [];
    for (let i = 0; i < 24; i++) {
      const hour = i < 10 ? `0${i}` : i;
      times.push(`${hour}:00:00`);
      times.push(`${hour}:30:00`);
    }
    return times;
  };

  const getTime = (time) => {
    // Extract hours and minutes from the input time
    const [hours, minutes] = time.split(":").map(Number);

    // Calculate the next half-hour mark
    const roundedMinutes = minutes;
    const roundedHours = hours;
    // Format hours and minutes into HH:MM with seconds always set to 00
    return `${String(roundedHours).padStart(2, "0")}:${String(roundedMinutes).padStart(2, "0")}:00`;
  };

  const roundUpToNextHalfHour = (time) => {
    // Extract hours and minutes from the input time
    const [hours, minutes] = time.split(":").map(Number);

    // Calculate the next half-hour mark
    const roundedMinutes = minutes < 30 ? 30 : 0;
    const roundedHours = minutes < 30 ? hours : (hours + 1) % 24;
    // Format hours and minutes into HH:MM with seconds always set to 00
    return `${String(roundedHours).padStart(2, "0")}:${String(roundedMinutes).padStart(2, "0")}:00`;
  };

  const StartTimeElement = () => {
    const rawStartTime = formData?.start_time || "00:00:00"; // Default to "00:00:00" if undefined
    const roundedStartTime = getTime(rawStartTime.slice(0, 5));

    return (
      <div className="flex w-full">
        <select
          name="start_time"
          value={roundedStartTime}
          onChange={handleInputChange}
          className={`form-select cursor-pointer h-[30px] ${isFormDisabled ? "border-DFE2E5 bg-EDEDED text-868686" : "border-DFE2E5 bg-white text-434852"} rounded-md border focus:outline-hidden focus:ring-0 focus:border-1D5D9B  w-full active:border active:border-DFE2E5 text-xs block h-7 py-0 min-w-fit`}
          disabled={!showTime}
        >
          {generateTimeOptions().map((time) => (
            <option key={time} value={time}>
              {time.slice(0, 5)}
            </option>
          ))}
        </select>
        <div className="absolute right-[0.5px] top-1/2 transform -translate-y-1/2 pointer-events-none ">
          <TimerImg />
        </div>
      </div>

      // <LocalizationProvider dateAdapter={AdapterDayjs} >
      //       <DemoContainer components={['TimePicker']} >
      //            <TimePicker label="Basic time picker" />
      //       </DemoContainer>
      // </LocalizationProvider>
    );
  };

  const EndTimeElement = () => {
    const rawStartTime = formData?.end_time || "00:00:00";
    const roundedStartTime = getTime(rawStartTime.slice(0, 5));

    return (
      <div className="flex w-full">
        <select
          name="end_time"
          value={roundedStartTime}
          onChange={handleInputChange}
          className={`form-select cursor-pointer  rounded-md border h-[30px] ${isFormDisabled ? "border-DFE2E5 bg-EDEDED text-868686" : "border-DFE2E5 bg-white text-434852"} focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-xs block w-full h-7 py-0 min-w-fit`}
          disabled={!showTime}
        >
          {generateTimeOptions().map((time) => (
            <option key={time} value={time}>
              {time.slice(0, 5)}
            </option>
          ))}
        </select>
        <div className="absolute right-[0.5px] top-1/2 transform -translate-y-1/2 pointer-events-none">
          <TimerImg />
        </div>
      </div>
    );
  };

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    if (name === "showTime") setShowTime(checked);
    if (name === "showEndDate") setShowEndDate(checked);

    if (!checked) {
      if (name === "showTime")
        setFormData((prevFormData) => {
          const newFomData = { ...prevFormData };
          delete newFomData["start_time"];
          delete newFomData["end_time"];
          return newFomData;
        });
      if (name === "showEndDate")
        setFormData((prevFormData) => ({
          ...prevFormData,
          end_date: prevFormData?.start_date,
        }));
      // setFormData((prevFormData) => {
      //   const newFomData = { ...prevFormData };
      //   delete newFomData["end_date"]
      //   return newFomData
      // });
    }
  };

  const handleSelectPerson = (event, value, personCountAllowed) => {
    event.preventDefault();

    const isTaskCategory = formData?.category_id?.toLowerCase() === "task";
    const currentAssignedTo = formData.assigned_to || [];

    if (isTaskCategory) {
      const index = currentAssignedTo.indexOf(value);
      if (index === -1) {
        setFormData({
          ...formData,
          assigned_to: [...formData?.assigned_to, value]?.slice(-personCountAllowed),
        });
      } else {
        setFormData({
          ...formData,
          assigned_to: [],
        });
      }
    } else {
      const index = currentAssignedTo.indexOf(value);
      if (index === -1) {
        setFormData({
          ...formData,
          assigned_to: [...currentAssignedTo, value],
        });
      } else {
        setFormData({
          ...formData,
          assigned_to: currentAssignedTo.filter((item) => item !== value),
        });
      }
    }
  };

  const handleRemovePerson = (e, person) => {
    e.stopPropagation();
    setFormData((prevFormData) => ({
      ...prevFormData,
      assigned_to: prevFormData.assigned_to.filter((item) => item.id !== person.id),
    }));
  };

  const handleSubTaskPerson = (subTaskIndex, value) => {
    const updatedSubTasks = [...formData.sub_tasks];

    // Update the subtask at the specified index
    const updatedSubTask = { ...updatedSubTasks[subTaskIndex] };

    // Check if the person is already assigned
    const isAlreadyAssigned = updatedSubTask.assigned_to.some((person) => person.id === value.id);

    if (isAlreadyAssigned) {
      // Remove the person if already assigned
      updatedSubTask.assigned_to = [];
    } else {
      // Add the person (only one select at a time)
      updatedSubTask.assigned_to = [value];
    }

    // Update the subtask in the array
    updatedSubTasks[subTaskIndex] = updatedSubTask;

    // Update the form data with the new subtask assignments
    setFormData({
      ...formData,
      sub_tasks: updatedSubTasks,
    });
  };

  const getCreatePortalPosition = () => {
    if (taskassignedtoref.current) {
      const rect = taskassignedtoref.current.getBoundingClientRect(); // Get the bounding rectangle

      const left = rect.left + 18;
      const top = rect.top + 5;

      return {
        top: top + window.scrollY,
        left: left + window.scrollX,
        borderRadius: "5",
      };
    }
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;

      if (formData?.status && formData?.sub_tasks?.length && formData?.status?.toLowerCase() === "completed") {
        handleMainTaskCheckboxChange({ target: { checked: formData?.status?.toLowerCase() === "completed" } });
      }
    }
  }, [formData]);

  useEffect(() => {
    if (formData?.status?.toLowerCase() === "hold" || formData?.status?.toLowerCase() === "not started") {
      return;
    }

    const allSubtasksInProgress = formData?.sub_tasks?.some(
      (subtask) =>
        subtask.status?.toLowerCase() === "not started" ||
        subtask.status?.toLowerCase() === "work in progress" ||
        subtask.status?.toLowerCase() === "hold"
    );

    if (allSubtasksInProgress) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        status: "Work in Progress",
      }));
    }
  }, [formData?.sub_tasks]);

  const handleMainTaskCheckboxChange = (e) => {
    const newStatus = e.target.checked ? "Completed" : "Work in Progress";

    setFormData({
      ...formData,
      status: newStatus,
      sub_tasks: formData?.sub_tasks?.map((subtask) => {
        if (
          subtask.status?.toLowerCase() !== "completed" &&
          subtask.status?.toLowerCase() !== "cancelled" &&
          subtask.status?.toLowerCase() !== "drop"
        ) {
          return {
            ...subtask,
            status: newStatus === "Completed" ? "Completed" : "Work in Progress",
          };
        }
        return subtask;
      }),
    });
  };

  const handleSubtaskCheckboxChange = (subtaskData, isChecked, index) => {
    const updatedSubtasks = formData.sub_tasks.map((subtask, subtaskIndex) => {
      if (subtask.id === subtaskData?.id && subtaskIndex === index) {
        if (isChecked) {
          return {
            ...subtask,
            status: "Completed",
          };
        } else {
          return {
            ...subtask,
            status: "Work in Progress",
          };
        }
      }
      return subtask;
    });

    setFormData({
      ...formData,
      sub_tasks: updatedSubtasks,
    });
  };

  const isEditTask = Boolean(taskid?.id);

  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const isFormDisabled = formDisabledStatuses.includes(formData?.status);

  const handlebackButton = () => {
    if (showSubtaskForm) {
      handleRemoveNoSubjectSubTask();
      setShowSubtaskForm(false);
    } else {
      closePopup();
    }
  };

  const getConditionalCategoryMenu = () => {
    const conditonalCategoryMenu = customerCommonData?.data?.task_category || [];
    // if (taskid?.category_id === "project") {
    //   return [{ value: "project", id: "project", name: "project" }];
    // } else if (!taskid?.category_id) {
    //   return [...conditonalCategoryMenu, { value: "project", id: "project", name: "project" }];
    // } else {
    //   return conditonalCategoryMenu;
    // }
    return [
      ...conditonalCategoryMenu,
      // { value: "project", id: "project", name: "project" },
      // { value: "deal", id: "deal", name: "deal" },
    ];
  };

  const handleAddTaskPod = () => {
    setOpenAddNewPodModal(true);
    setFormData((prevFormData) => ({ ...prevFormData, task_pod: "" }));
  };
  const handleAddProject = () => {
    setOpenAddProject("add");
  };

  const getFieldValue = async (enumValues, entity = "project") => {
    const payload = {
      entity: entity,
      field: enumValues,
    };
    const response = await fetchFieldValues({ payload }).unwrap();
    if (response?.success) {
      dispatch(pushAlert({ message: response?.message, type: "success", visible: true }));
    } else {
      dispatch(pushAlert({ message: response?.message, type: "danger", visible: true }));
    }
  };

  const getServiceList = () => {
    const payload = {
      customer_id: formData?.customer_id,
    };
    fetchServiceList({ payload });
  };

  const handleUpdateTags = async ({ oldTag, newTag }) => {
    const payload = {
      tag_name: newTag,
      default_tag_name: oldTag?.default_label,
      id: oldTag?.value,
    };
    const response = await updateTagsData({ payload }).unwrap();
    if (response.success) {
      dispatch(pushAlert({ message: response?.message, type: "success", visible: true }));
      // console.log("hit me aakash");
      fetchTaskTags("", false);
    } else {
      dispatch(pushAlert({ message: response?.message, type: "danger", visible: true }));
    }
  };

  const projectFields0 = [
    {
      id: "customer_id",
      name: "customer_id",
      label: "Customer",
      type: "select",
      value: formData?.customer_id,
      displayValueKey: "customer_name",
      defaultOptions: customerTaskPodAllCustomer?.data?.customers?.map((item) => ({
        label: item.customer_name,
        value: item.customer_id,
      })),
      colspan: "2",
      hide: formData?.project_id,
      isMandatory: true,
      disabled: Boolean(selectedCustomer?.id || selectedCustomer?.customer_id || taskid?.customer_id || customerId),
      useFetchHook: useLazyGetProjectTaskEnumQuery,
    },
    {
      id: "category_id",
      name: "category_id",
      label: "Category",
      type: "select",
      value: formData?.category_id,
      defaultOptions: GetAlltemplates?.data?.map((item) => ({
        label: getSentenceCase(item?.template_name),
        value: item?.id,
      })),
      disabled: Boolean(taskid?.customer_id),
      colspan: "2",
      hide: formData?.project_id,
      isMandatory: true,
      useFetchHook: useLazyGetProjectTaskEnumQuery,
    },

    {
      id: "project_id",
      name: "project_id",
      label: "Project Name",
      type: "select",
      value: formData?.project_id,
      displayValueKey: "project_name",
      disabled: !Boolean(formData?.customer_id),

      // useFetchHook:useLazyFetchAllProjectsQuery,
      // hookPayload:({ customerId: formData?.customer_id }),
      apiCall: fetchAllProjectsCall,
      dynamicOptions: projectsAllData?.data?.map((eachItem) => ({
        label: eachItem.project_name,
        value: eachItem.project_id,
      })),
      isLoading: projectsAllDataLoading,
      hide: formData?.category_id !== "project",
      colspan: "2",
      addButton: true,
      addButtonLabel: "+ Add New Project",
      addButtonAction: handleAddProject,
      isMandatory: true,
      useFetchHook: useLazyGetProjectTaskEnumQuery,
    },

    {
      id: "job_status_funnel",
      name: "job_status_funnel",
      label: formData?.category_id === "project" ? "Tax Milestone" : "Funnel", // as told by bhatia sir on 0107, didnt changed the condition, may be needed to revert it back
      type: "select",
      value: formData?.job_status_funnel,
      // dynamicOptions:projectFieldList?.data?.map((eachItem) => ({ label: eachItem, value: eachItem })),
      isLoading: projectFieldListLoading,
      // apiCall: function() {
      //   return getFieldValue("job_status","job");
      // },
      useFetchHook: useLazyGetProjectTaskEnumQuery,
      hookPayload: {
        entity: "task",
        field: "job_status_funnel",
      },

      hide: !["deal"].includes(formData?.category_id?.toLowerCase()),
    },

    {
      id: "service_id",
      name: "service_id",
      label: "Link To Service",
      type: "select",
      value: formData?.service_id,
      displayValueKey: "service_name",
      hide: formData?.category_id !== "deal",
      colspan: "2",
      noKeyboardNavigation: true,
      childrenKey: "sub_services",
      apiCall: function () {
        return getServiceList();
      },
      dynamicOptions: serviceList?.data?.map((eachItem) => ({
        label: eachItem?.name,
        value: eachItem?.id,
        children: eachItem?.sub_services?.map((eachTask) => ({
          label: eachTask?.name,
          value: eachTask?.id,
        })),
      })),
      isLoading: serviceListLoading,
      isMandatory: formData?.category_id === "project",
      useFetchHook: useLazyGetProjectTaskEnumQuery,
    },
  ];

  const projectFields1 = [
    {
      id: "job_name",
      name: "job_name",
      label: "Job Name",
      type: "text",
      value: formData?.job_name,
      disabled: true,
      colspan: "2",
      // isMandatory: true,
      useFetchHook: useLazyGetProjectTaskEnumQuery,
    },

    {
      id: "job_status_funnel",
      name: "job_status_funnel",
      label: formData?.category_id === "project" ? "Tax Milestone" : "Funnel", // as told by bhatia sir on 0107, didnt changed the condition, may be needed to revert it back
      type: "select",
      value: formData?.job_status_funnel,
      // dynamicOptions:projectFieldList?.data?.map((eachItem) => ({ label: eachItem, value: eachItem })),
      isLoading: projectFieldListLoading,
      // apiCall: function() {
      //   return getFieldValue("job_status","job");
      // },
      useFetchHook: useLazyGetProjectTaskEnumQuery,
      hookPayload: {
        entity: "task",
        field: "job_status_funnel",
      },

      hide: !["deal", "project"].includes(formData?.category_id?.toLowerCase()),
      colspan: "2",
    },

    {
      id: "project_period",
      name: "project_period",
      label: "Job Period",
      type: "date",
      noInput: true,
      // value: formData?.project_start_date,
      disabled: true,
      // hide: formData?.category_id !== "project",
      useFetchHook: useLazyGetProjectTaskEnumQuery,
      // noLabel: true,
      colspan: 2,
    },

    {
      id: "project_start_date",
      name: "project_start_date",
      label: "Period Start Date",
      type: "date",
      placeholder: "Job Start Date",
      value: formData?.project_start_date,
      disabled: true,
      noLabel: true,
      // hide: formData?.category_id !== "project",
      useFetchHook: useLazyGetProjectTaskEnumQuery,
      // noLabel: true,
      colspan: 1,
    },
    {
      id: "project_end_date",
      name: "project_end_date",
      label: "Period End Date",
      type: "date",
      placeholder: "Job End Date",
      value: formData?.project_end_date,
      disabled: true,
      noLabel: true,
      // hide: formData?.category_id !== "project",
      useFetchHook: useLazyGetProjectTaskEnumQuery,
      // noLabel: true,
      colspan: 1,
    },
    // {
    //   id: "due_date",
    //   name: "due_date",
    //   label: "Due Date",
    //   type: "dateTimeCombo",
    //   value: formData?.due_date,
    //   hide: formData?.category_id === "project",
    //   colspan: "2",
    //   useFetchHook: useLazyGetProjectTaskEnumQuery,
    //   // noLabel: true,
    // },

    // {
    //   id: "service_id",
    //   name: "service_id",
    //   label: "Link To Service",
    //   type: "select",
    //   value: formData?.service_id,
    //   displayValueKey: "service_name",
    //   // hide: formData?.category_id !== "project",
    //   colspan: "2",
    //   noKeyboardNavigation: true,
    //   childrenKey: "sub_services",
    //   apiCall: function () {
    //     return getServiceList();
    //   },
    //   dynamicOptions: serviceList?.data?.map((eachItem) => ({
    //     label: eachItem?.name,
    //     value: eachItem?.id,
    //     children: eachItem?.sub_services?.map((eachTask) => ({
    //       label: eachTask?.name,
    //       value: eachTask?.id,
    //     })),
    //   })),
    //   isLoading: serviceListLoading,
    //   isMandatory: formData?.category_id === "project",
    //   useFetchHook: useLazyGetProjectTaskEnumQuery,
    // },
  ];

  const projectFields2 = [
    {
      id: "service_id",
      name: "service_id",
      label: "Link To Service",
      type: "select",
      value: formData?.service_id,
      displayValueKey: "service_name",

      colspan: "2",
      noKeyboardNavigation: true,
      childrenKey: "sub_services",
      apiCall: function () {
        return getServiceList();
      },
      dynamicOptions: serviceList?.data?.map((eachItem) => ({
        label: eachItem?.name,
        value: eachItem?.id,
        children: eachItem?.sub_services?.map((eachTask) => ({
          label: eachTask?.name,
          value: eachTask?.id,
        })),
      })),
      isLoading: serviceListLoading,
      isMandatory: formData?.category_id === "project",
      useFetchHook: useLazyGetProjectTaskEnumQuery,
    },

    {
      id: "return_type",
      name: "return_type",
      label: "Return Type",
      type: "select",
      value: formData?.return_type,
      // dynamicOptions: projectFieldList?.data?.map((eachItem) => ({ label: eachItem, value: eachItem })),
      // isLoading: projectFieldListLoading,
      useFetchHook: useLazyGetProjectTaskEnumQuery,
      hookPayload: {
        entity: "job",
        field: "return_type",
      },
      // apiCall: function() {
      //   return getFieldValue("return_type","job");
      // },
      hide: serviceList?.data
        ? serviceList.data.find((eachItem) => eachItem?.id === formData?.service_id)?.name !== "Tax"
        : formData?.service_name !== "Tax",
    },
    {
      id: "complexity",
      name: "complexity",
      label: "Complexity",
      type: "select",
      value: formData?.complexity,
      hide: serviceList?.data
        ? serviceList.data.find((eachItem) => eachItem?.id === formData?.service_id)?.name !== "Tax"
        : formData?.service_name !== "Tax",
      // dynamicOptions:projectFieldList?.data?.map((eachItem) => ({ label: eachItem, value: eachItem })),
      isLoading: projectFieldListLoading,
      useFetchHook: useLazyGetProjectTaskEnumQuery,
      hookPayload: {
        entity: "job",
        field: "complexity",
      },
      // apiCall: function() {
      //   return getFieldValue("complexity","job");
      // },
    },

    {
      id: "target_delivery_date",
      name: "target_delivery_date",
      label: "Target delivery date",
      type: "date",
      value: formData?.target_delivery_date,
      useFetchHook: useLazyGetProjectTaskEnumQuery,
      disabled: true,
    },

    {
      id: "budgeted_hours",
      name: "budgeted_hours",
      label: "Budgeted hours",
      type: "hours",
      value: formData?.budgeted_hours,
      useFetchHook: useLazyGetProjectTaskEnumQuery,
      disabled: true,
    },
  ];

  const projectFields3 = [
    {
      id: "subject",
      name: "subject",
      label: "Task Name",
      type: "text",
      value: formData?.subject,
      disabled: true,
      colspan: "2",
      isMandatory: true,
      useFetchHook: useLazyGetProjectTaskEnumQuery,
    },
    {
      id: "service_id",
      name: "service_id",
      label: "Link To Service",
      type: "select",
      value: formData?.service_id,
      displayValueKey: "service_name",
      hide: ["project", "deal"].includes(formData?.category_id),
      colspan: "2",
      noKeyboardNavigation: true,
      childrenKey: "sub_services",
      apiCall: function () {
        return getServiceList();
      },

      dynamicOptions: serviceList?.data?.map((eachItem) => ({
        label: eachItem?.name,
        value: eachItem?.id,
        children: eachItem?.sub_services?.map((eachTask) => ({
          label: eachTask?.name,
          value: eachTask?.id,
        })),
      })),
      isLoading: serviceListLoading,
      isMandatory: formData?.category_id === "project",
      useFetchHook: useLazyGetProjectTaskEnumQuery,
    },
    {
      id: "priority",
      name: "priority",
      label: "Priority",
      type: "select",
      value: formData?.priority,
      defaultOptions: customerCommonData?.data?.priority?.map((item) => ({ label: item.value, value: item.value })),
      colspan: "2",
      useFetchHook: useLazyGetProjectTaskEnumQuery,

      // hide: formData?.category_id === "project",
    },

    {
      id: "job_period",
      name: "job_period",
      label: "Period",
      type: "dateTimeCombo",
      value: formData?.job_period,
      disabled: true,
      // hide: formData?.category_id !== "project",
      colspan: "2",
      noLabel: true,
      isMandatory: true,
      useFetchHook: useLazyGetProjectTaskEnumQuery,
    },
    // {
    //   id: "due_time",
    //   name: "due_time",
    //   label: "",
    //   type: "",
    //   value: formData?.due_time,
    //   hide: formData?.category_id !== "project",
    //   useFetchHook: useLazyGetProjectTaskEnumQuery,
    //   // noLabel: true,
    // },

    {
      id: "status",
      name: "status",
      label: "Status",
      type: "select",
      value: formData?.status,
      noDisabled: true,
      defaultOptions: customerCommonData?.data?.status?.map((item) => ({ label: item.value, value: item.value })),
      useFetchHook: useLazyGetProjectTaskEnumQuery,
    },
    {
      id: "tag",
      name: "tag",
      label: "Tags",
      type: "tags",
      value: formData?.tag,
      dynamicOptions: TaskTagsList?.map((eachItem) => ({
        ...eachItem,
        label: eachItem.tag_name,
        value: eachItem.id,
        color_code: eachItem?.colour_code,
        bg_code: eachItem?.bg_code,
        default_label: eachItem?.default_tag_name,
      })),
      // colspan: "2",
      // hide: formData?.tag,
      // isMandatory: true,
      updateTags: handleUpdateTags,
      clickTrigger: () => fetchTaskTags("", false),
      useFetchHook: useLazyGetProjectTaskEnumQuery,
    },

    {
      id: "task_pod",
      name: "task_pod",
      label: `Link to ${getSentenceCase(GetAlltemplates?.data?.find((item) => item.id === formData?.category_id)?.template_name)} Pod`,
      type: "select",
      value: formData?.task_pod,
      addButton: true,
      addButtonLabel: `+ Add ${["project", "deal"].includes(formData?.category_id?.toLowerCase()) ? `${formData?.category_id} Pod` : "Taskpod"} `,
      defaultOptions: newTaskpodsAll?.data?.pods?.map((item) => ({ label: item.pod_name, value: item.pod_name })),
      addButtonAction: handleAddTaskPod,
      // colspan: formData?.category_id?.toLowerCase() === "project" ? "2" : "1",
      useFetchHook: useLazyGetProjectTaskEnumQuery,
      // colspan: formData?.category_id === "deal"?"2":"1",
    },
  ];

  const projectFields4 = [
    {
      id: "billing_status",
      name: "billing_status",
      label: "Billing Status",
      type: "select",
      value: formData?.billing_status,
      noDisabled: true,
      formSaveKey: "billing_details",
      isLoading: projectFieldListLoading,
      useFetchHook: useLazyGetProjectTaskEnumQuery,
      hookPayload: {
        entity: "billing",
        field: "billing_status",
      },
    },

    {
      id: "invoice_number",
      name: "invoice_number",
      label: "Invoice Number",
      type: "text",
      value: formData?.invoice_number,
      noDisabled: true,
      formSaveKey: "billing_details",
      useFetchHook: useLazyGetProjectTaskEnumQuery,
    },
    {
      id: "billing_date",
      name: "billing_date",
      label: "Invoice Date",
      type: "date",
      value: formData?.billing_date,
      noDisabled: true,
      formSaveKey: "billing_details",
      useFetchHook: useLazyGetProjectTaskEnumQuery,
    },
    {
      id: "payment_status",
      name: "payment_status",
      label: "Payment Status",
      type: "select",
      value: formData?.payment_status,
      noDisabled: true,
      formSaveKey: "billing_details",
      useFetchHook: useLazyGetProjectTaskEnumQuery,
      hookPayload: {
        entity: "billing",
        field: "payment_status",
      },
    },
    {
      id: "target_delivery_date",
      name: "target_delivery_date",
      label: "Target Delivery Date",
      type: "date",
      value: formData?.target_delivery_date,
      noDisabled: true,
      formSaveKey: "billing_details",
      useFetchHook: useLazyGetProjectTaskEnumQuery,
    },
    {
      id: "time_tracked",
      name: "time_tracked",
      label: "Time Booked",
      type: "time",
      value: formData?.time_tracked,
      noDisabled: true,
      formSaveKey: "billing_details",
      useFetchHook: useLazyGetProjectTaskEnumQuery,
    },
  ];

  const handleLeadType = (value) => {
    // setLeadType(value);
    setCategory({ name: "category_id", value });
    handleInputChange({ target: { name: "category_id", value: value } });
  };

  const handleRemoveProjectFields = () => {
    setFormData((prevFormData) => {
      const updatedFormData = structuredClone(prevFormData);
      projectFields1?.forEach((key) => delete updatedFormData[key]);
      projectFields2?.forEach((key) => delete updatedFormData[key]);
      return updatedFormData;
    });
  };

  const getProjectFields = ({ projectFields }) => (
    <>
      {projectFields
        ?.filter((item) => !item?.hide)
        .map((eachField) => (
          <div
            className={`basis-5/5 mb-1 col-span-${eachField.colspan ?? "1"}`}
            style={{ margin: eachField?.noInput && "0px" }}
          >
            {!eachField?.noLabel && (
              <LabelComponent
                labelText={eachField?.label}
                htmlFor={eachField?.label}
                size="small"
                isMandatory={eachField?.isMandatory}
                isFormDisabled={isFormDisabled}
              />
            )}
            {!eachField?.noInput && (
              <div className="flex items-center">
                {eachField?.type === "dateTimeCombo" ? (
                  <DateTimeCombo
                    innerLabel={"Task Due Date"}
                    name={eachField?.name}
                    showEndDate={showEndDate}
                    showTime={showTime}
                    handleCheckboxChange={handleCheckboxChange}
                    openPopup={openPopup}
                    isPopupOpen={isPopupOpen}
                    isFormDisabled={isFormDisabled}
                    formData={formData}
                    setIsPopupOpen={setIsPopupOpen}
                    ActivateRecur={ActivateRecur}
                    closePopupRecur={closePopupRecur}
                    taskid={taskid}
                    setStartDate={setStartDate}
                    startDate={startDate}
                    setEndDate={setEndDate}
                    endDate={endDate}
                    StartTimeElement={StartTimeElement}
                    Fragment={Fragment}
                    EndTimeElement={EndTimeElement}
                    setFormData={setFormData}
                    StartDateChange={StartDateChange}
                    isMandatory={eachField?.isMandatory}
                    drawerRef={drawerRef}
                  />
                ) : (
                  <AdvancedFieldElements
                    {...eachField}
                    id={eachField?.id}
                    name={eachField?.name}
                    label={eachField?.label}
                    placeholder={eachField?.placeholder}
                    value={eachField?.value}
                    displayValueKey={eachField?.displayValueKey}
                    onChange={handleInputChange}
                    disabled={eachField?.disabled}
                    isFormDisabled={isFormDisabled}
                    // defaultOptions={selectionList}
                    type={eachField?.type}
                    noKeyboardNavigation={eachField?.noKeyboardNavigation}
                    childrenKey={eachField?.childrenKey}
                    formData={formData}
                    taskid={taskid}
                    defaultOptions={eachField?.defaultOptions}
                    dynamicOptions={eachField?.dynamicOptions}
                    apiCall={eachField?.apiCall}
                    addButton={eachField?.addButton}
                    addButtonLabel={eachField?.addButtonLabel}
                    addButtonAction={eachField?.addButtonAction}
                    isLoading={eachField?.isLoading}
                    useFetchHook={eachField?.useFetchHook}
                    hookPayload={eachField?.hookPayload}
                    noDisabled={eachField?.noDisabled}
                    helperText={`Enter ${eachField?.label}`}
                    mandatory={eachField?.isMandatory}
                  />
                )}
                {/* {getFieldElements(
         { id:eachField?.id,name:eachField?.name,label:eachField?.label,onChange:handleInputChange,disabled:eachField?.disabled,isFormDisabled:eachField?.isFormDisabled,selectionList,type:eachField?.type}
       )} */}
              </div>
            )}
          </div>
        ))}
    </>
  );

  const handleCheckClosePopup = () => {
    if (!formData?.customer_id && !formData?.subject) {
      closePopup();
    } else {
      // hasFormChanged && categoryChange?.name?.toLowerCase() === "category_id"
      setOpenConfirmationDialog("all_discard_and_close");
    }
  };

  const checkAndPerformOperation = (key) => {
    switch (key) {
      case "all_discard_and_close":
        setCategory({ name: "category_id", value: formData?.category_id });
        setFormData({});
        setOpenConfirmationDialog(false);
        closePopup();
        break;

      case "close_only_confirmation_dialog":
        setCategory({ name: "category_id", value: formData?.category_id });
        setOpenConfirmationDialog(false);

        break;

      case "discard_subtask_and_switch_to_non-task":
        handleRemoveSubtasks();
        handleCategoryUpdate();
        setOpenConfirmationDialog(false);
        setShowSubtaskForm("");

        break;

      case "discard_project_and_switch_to_other_task":
        handleRemoveSubtasks();
        handleRemoveChecklist();
        handleCategoryUpdate();
        handleRemoveProjectFields();
        setOpenConfirmationDialog(false);
        setShowSubtaskForm("");
        break;

      default:
        break;
    }
  };

  const handleOpenAddTaskPod = () => {
    setOpenAddNewPodModal(true);
  };

  const getCategoryValue = (value) => {
    const taskCatergoryList = customerCommonData?.data?.task_category;
    const projectCategoryList = ["project"];
    if (projectCategoryList.includes(formData?.category_id)) {
      return formData?.category_id === value;
    } else {
      return taskCatergoryList?.some((eachCategory) => eachCategory.value?.toLowerCase() === value);
    }
  };

  const handleChangeStatusWIP = () => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      status: "Work in Progress",
    }));
  };

  const NewProject = () => (
    <div className="p-2 col-span-2 border border-[#D2DAE1] rounded-md w-full">
      <table className="w-full">
        <tr>
          <td className="text-[#848687] font-300 text-xs">Customer Name</td>
          <td className="text-[#2C495D] font-400 text-sm">
            <span className="text-[#848687] font-300 text-xs mr-3">:</span>CNRG Accounting Advisory LLCc
          </td>
          <td>
            <button onClick={() => setOpenAddProject("view")}>
              <img src={expandButton} />
            </button>
          </td>
        </tr>
        <tr>
          <td className="text-[#848687] font-300 text-xs">Project Name</td>
          <td className="text-[#2C495D] font-400 text-sm">
            <span className="text-[#848687] font-300 text-xs mr-3">:</span>CNRG
          </td>
        </tr>
        <tr>
          <td className="text-[#848687] font-300 text-xs">Software</td>
          <td className="text-[#2C495D] font-400 text-sm">
            <span className="text-[#848687] font-300 text-xs  mr-3">:</span>Project
          </td>
        </tr>
      </table>
    </div>
  );

  const handleLinkClick = () => {
    setIsLinkOpen((prev) => !prev);
  };

  return (
    <CustomDrawer
      open={true}
      onClose={closePopup}
      anchor="right"
      width="25vw"
      variant="temporary"
      showSubDrawer={
        showNotification || showSubtaskForm === "task" || showSubtaskForm === "project" || isPopupOpen || isLinkOpen
      }
    >
      <div className=" font-popns w-full py-0 flex flex-col h-full" ref={drawerRef}>
        <div className="border-b py-2 px-3 border-BECBD3 flex justify-between items-center">
          <div className="flex items-center justify-center">
            {/* {console.log(showSubtaskForm, showNotification, "hellotalib")} */}
            {showSubtaskForm && showSubtaskForm !== "task" && (
              <button onClick={handlebackButton} className="mr-2">
                <BackIcon />
              </button>
            )}
            {(showSubtaskForm === "task" || !showSubtaskForm) && isEditTask && (
              <Checkbox
                {...label}
                checked={
                  formData?.status === "Completed" || formData?.status === "Drop" || formData?.status === "Cancelled"
                }
                // onChange={(e) => handleSubtaskCheckboxChange(subtask, e.target.checked)}
                icon={<i className="bi bi-square text-434852"></i>}
                checkedIcon={
                  formData?.status === "Completed" ? (
                    <i className="bi bi-check-square-fill text-green-500"></i>
                  ) : formData?.status === "Drop" || formData?.status === "Cancelled" ? (
                    <i className="bi bi-check-square-fill text-red-500"></i>
                  ) : (
                    <i className="bi bi-square text-434852"></i>
                  )
                }
                onChange={handleMainTaskCheckboxChange}
              />
            )}
            {"  "}
            <div className="text-lg">
              {showSubtaskForm ? (
                formData?.category_id?.toLowerCase() === "task" ? (
                  <span>
                    {" "}
                    {/* {`Sub-Task ${Boolean(formData?.sub_tasks?.length > 0) ? `(${formData?.sub_tasks?.length})` : ""}`} */}
                    {formData?.customer_name}
                  </span>
                ) : (
                  <span className="text-[#1D4469] font-600">{` Checklist ${Boolean(formData?.checklists?.length > 0) ? `(${formData?.checklists?.length})` : ""}`}</span>
                )
              ) : isEditTask ? (
                `${formData?.customer_name}`
              ) : (
                <p className="flex items-center text-lg font-medium text-[#1D4469] ">
                  Create Task
                  {/* {leadTypeList.map((eachItem, i) => (
                    <button
                      disabled={disableLeadTypeChange}
                      onClick={() => handleLeadType(eachItem)}
                      className={`flex ${disableLeadTypeChange ? "cursor-not-allowed" : "cursor-pointer"}`}
                    >
                      <div
                        className={`${getCategoryValue(eachItem) ? "text-[white] bg-[#2999BC] border-[#D2DAE1] border" : "text-[#848687] border  border-[#D2DAE1]"} px-4 py-1 mx-1 rounded-3xl min-w-28 capitalize`}
                      >
                        {" "}
                        {eachItem}
                      </div>
                      {i < 1 && <span className="border-[1.5px] border-[#5B646C] h-8"></span>}
                    </button>
                  ))} */}
                </p>
              )}
            </div>

            {isEditTask && (
              <button
                style={{ marginLeft: "8px" }}
                onClick={() => {
                  setIsLinkOpen(false);
                  handleNotification();
                  setShowSubtaskForm(false);
                }}
              >
                {<MenuBar />}
              </button>
            )}

            {taskid && (
              <button
                onClick={() => {
                  handleLinkClick();
                  setShowNotification(false);
                }}
                style={{ marginLeft: "8px" }}
              >
                <Share />
              </button>
            )}

            {/* <button style={{ marginLeft: "8px" }}>
                <Share />
              </button> */}
          </div>
          <div className="flex items-center">
            {showSubtaskForm && showSubtaskForm !== "task" && showSubtaskForm !== "project" && (
              <div
                className={`w-fit h-[26px] px-2  bg-2999BC  border border-EBEBEB flex justify-center items-center rounded-md ${formData?.sub_tasks?.some((subtask) => subtask.subject === "") ? "pointer-events-none cursor-not-allowed opacity-50" : ""}`}
                onClick={() => (formData?.category_id?.toLowerCase() === "task" ? addSubtask() : addChecklist())}
              >
                <span className="text-[12px] text-white hover:cursor-pointer ">
                  {" "}
                  <i class="bi bi-plus text-white"></i> Add{" "}
                  {formData?.category_id?.toLowerCase() === "task" ? "More" : "More"}
                </span>
              </div>
            )}
            <button
              onClick={closePopup}
              type="button"
              className="text-454545 bg-transparent hover:bg-F1F5F8 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
              data-modal-hide="assets-modal"
            >
              <CloseModalImg className="w-3 h-3" />
              <span className="sr-only">Close modal</span>
            </button>
          </div>
        </div>
        {(!showSubtaskForm || showSubtaskForm === "task" || showSubtaskForm === "project") && (
          <div className="flex flex-col flex-1 grow min-h-0">
            {/* <div className=" flex items-center justify-between rounded-t">
                <div className="flex items-center"></div> */}

            {/* {!showNotification && (
                  <div>
                    {isEditTask && (
                      <button onClick={handleNotification}>
                        <HandleNotificationexpandshyrink />
                      </button>
                    )}
                  </div>
                )} */}
            {/* </div> */}
            <form
              id={tableDetail?.tableidclass}
              onSubmit={handleSubmitTask}
              className={`w-full flex flex-col justify-between flex-1 grow min-h-0 relative ${tableDetail?.tableidclass}`}
            >
              {formData?.project_id && (
                <div className="border-b col-span-2 border-[#BECBD3] p-3">
                  <ProjectDetails projectId={formData?.project_id} setOpenAddProject={setOpenAddProject} />
                </div>
              )}

              {false && !formData?.project_id && (
                <CustomAccordion defaultOpen label="Project/Task Summary" width="100%" height="100%">
                  {/* Section1 Starts */}
                  <div className="border-bcol-span-2 border-[#BECBD3] py-2">
                    {/* {formData?.project_id && (
                        <ProjectDetails projectId={formData?.project_id} setOpenAddProject={setOpenAddProject} />
                      )} */}
                  </div>
                </CustomAccordion>
              )}

              {!formData?.project_id && (
                <div className=" border-[#BECBD3] p-3 py-2">
                  {getProjectFields({
                    projectFields: projectFields0,
                  })}
                </div>
              )}

              {/* Section2 Starts */}
              {formData?.category_id?.toLowerCase() === "project" &&
                formData?.status?.toLowerCase() === "completed" && (
                  <JobSummary formData={formData} handleChangeStatusWIP={handleChangeStatusWIP} />
                )}
              <div className="grow min-h-0 overflow-auto">
                <div className=" grid grid-cols-2 gap-4 gap-y-1  ">
                  <div className="max-h-fit col-span-2 grid grid-cols-2 gap-4 gap-y-0">
                    {formData?.category_id?.toLowerCase() === "project" &&
                      formData?.status?.toLowerCase() !== "completed" && (
                        <CustomAccordion defaultOpen label="Job Information" width="100%" height="100%">
                          <div className="grid grid-cols-2 gap-x-2 py-2">
                            {getProjectFields({
                              projectFields: projectFields1,
                            })}

                            {/* Set Time */}
                            {/* {formData?.category_id?.toLowerCase() !== "project" && <SetTimeComponent />} */}

                            {formData?.category_id?.toLowerCase() === "project" &&
                              getProjectFields({
                                projectFields: projectFields2,
                              })}
                          </div>
                        </CustomAccordion>
                      )}

                    {/* Section 4 for Billing Details */}
                    {!(
                      formData?.category_id?.toLowerCase() === "project" &&
                      formData?.status?.toLowerCase() === "completed"
                    ) && (
                      <CustomAccordion defaultOpen label="Task Information" width="100%" height="100%">
                        <div className="grid grid-cols-2 gap-x-2 py-2">
                          {getProjectFields({
                            projectFields: projectFields3,
                          })}
                          <DelegationMultiSelect
                            formData={formData}
                            isFormDisabled={isFormDisabled}
                            isSearchBarOpen={isSearchBarOpen}
                            taskassignedtoref={taskassignedtoref}
                            handleMouseEnter={handleMouseEnter}
                            handleMouseLeave={handleMouseLeave}
                            handleCheck={handleCheck}
                            personTableData={personTableData || []}
                            handleSelectPerson={handleSelectPerson}
                            handleRemovePerson={handleRemovePerson}
                            searchTerm={searchTerm}
                            isEditTask={isEditTask}
                            depth="D0"
                            personCountAllowed={1}
                          />

                          {/* Subtask */}

                          {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4"> */}
                          {false &&
                            (formData?.category_id?.toLowerCase() === "task" ||
                              formData?.category_id?.toLowerCase() === "project") && (
                              <div className="bg-[#F1F6F9] border border-[#D2DAE1] rounded-md my-2 col-span-2 p-2">
                                <div className="flex justify-between item-center">
                                  <button
                                    type="button"
                                    className={`flex items-center`}
                                    onClick={() => {
                                      setShowSubtaskForm(formData?.category_id?.toLowerCase());
                                      setShowNotification(false);
                                    }}
                                  >
                                    <span className=" text-434852 text-sm font-medium">
                                      {formData?.category_id?.toLowerCase() === "task" ? "Sub-Task" : "Checklist"}
                                      {formData?.sub_tasks?.length > 0 && ` (${formData?.sub_tasks?.length})`}
                                      {formData?.checklists?.length > 0 && ` (${formData?.checklists?.length})`}
                                      {formData?.sub_tasks?.some((subtask) => subtask.subject === "") && (
                                        <span className="text-red-700"> *</span>
                                      )}
                                    </span>

                                    {/* <span>
                                      <DownAngleBracket />
                                    </span> */}
                                  </button>
                                  <div
                                    className={`w-fit h-[26px] px-2 bg-FFFEFE border border-[#969BA9] flex justify-center items-center  rounded-md  `}
                                    onClick={() => {
                                      setShowSubtaskForm(formData?.category_id?.toLowerCase());
                                      setShowNotification(false);
                                      setIsPopupOpen(false);
                                    }}
                                  >
                                    <span className="text-sm text-[#969BA9] hover:cursor-pointer flex flex-row gap-2 items-center">
                                      {" "}
                                      {/* <i class="bi bi-plus text-[#969BA9] font-normal text-sm "></i> */}
                                      <PlusIcon /> Add{" "}
                                      {formData?.category_id?.toLowerCase() === "task" ? "Sub-Task" : "Checklist"}
                                      {/* <i class="bi bi-arrow-right text-[#969BA9] font-normal"></i> */}
                                    </span>
                                  </div>
                                </div>

                                {/* <hr className="h-[2px] bg-black/10 mx-2 my-2" /> */}

                                {/* </div> */}
                              </div>
                            )}

                          {/* Add SubTask */}

                          {/* Description */}
                          <div className="col-span-2">
                            <div className="basis-5/5 mb-3 col-span-3">
                              <LabelComponent
                                labelText="Description"
                                htmlFor="description"
                                size="small"
                                isFormDisabled={isFormDisabled}
                              />
                              <textarea
                                type="message"
                                id="description"
                                name="description"
                                placeholder="Type Something..."
                                value={formData?.description}
                                onChange={handleInputChange}
                                className={` rounded border ${isFormDisabled ? "border-DFE2E5 bg-EDEDED text-868686" : "border-DFE2E5 bg-white text-434852"} focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-xs block w-full h-[80px] resize-none `}
                              />
                              <div className="text-sm text-red-400"></div>
                            </div>
                          </div>
                          {/* remarks */}
                          {showRemark && (
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                              <div className="basis-5/5 mb-3 px-6 col-span-3">
                                <label htmlFor="remarks" className="font-medium	block mb-2 text-sm text-434852">
                                  Remarks
                                </label>
                                <textarea
                                  type="message"
                                  id="remarks"
                                  name="remarks"
                                  placeholder="Type Something..."
                                  value={formData?.remarks}
                                  onChange={handleInputChange}
                                  className="bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border focus:border-C4D3E2 focus:shadow-10 active:border active:border-DFE2E5 text-gray-900 text-sm block w-full max-h-fit h-[40px] min-h-[10px] resize-none"
                                />
                                <div className="text-sm text-red-400"></div>
                              </div>
                            </div>
                          )}
                        </div>
                      </CustomAccordion>
                    )}

                    {formData?.category_id?.toLowerCase() === "project" && (
                      <CustomAccordion defaultOpen label="Billing Details" width="100%" height="100%">
                        <div className="grid grid-cols-2 gap-x-2 py-2">
                          {getProjectFields({
                            projectFields: projectFields4,
                          })}
                        </div>
                      </CustomAccordion>
                    )}
                  </div>
                </div>
              </div>
              {/* Footer Starts */}

              <div className="sticky bottom-0 self-end border-y w-full flex justify-end border-BECBD3 p-3">
                <button
                  onClick={closePopup}
                  type="button"
                  className="w-28 text-383838 bg-F4F4F4 border border-[#D2DAE1] hover:bg-eeeeee cancel-btn focus:ring-4 focus:ring-blue-300 font-semibold px-5 py-1 text-center rounded-[5px]"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className={`w-28 text-white save-btn font-semibold border border-gray-200 py-1 px-5 ms-3 rounded-[5px] 
                              ${
                                //temporarily disabled the customer_name field, wasn't able to figure it out
                                //formData.customer_id === "" || formData.customer_name === ""
                                formData.customer_id === ""
                                  ? "bg-gray-400 cursor-not-allowed"
                                  : " bg-[#1D4469] border border-[#123251] hover:bg-[#20486F]"
                              }
                            `}
                  //temporarily disabled the customer_name field, wasn't able to figure it out
                  // disabled={formData.customer_id === "" || formData.customer_name === ""}
                  disabled={formData.customer_id === ""}
                >
                  Save
                </button>
              </div>
            </form>
            {getHasError(errors) && (
              <div className="sticky bottom-0 bg-white  flex justify-between py-4 z-50 text-md w-full rounded">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  {
                    <div className="basis-5/5 flex items-center px-1 col-span-3">
                      <span className="text-red-700">*Enter Mandatory Field</span>
                    </div>
                  }
                </div>
              </div>
            )}
          </div>
        )}

        {/* {showNotification && (
          <FloatingList zIndex={1200} margin={5} yMargin={0}>
            <div
              className={` h-full shadow-9  transform transition-transform duration-500 ease-in-out bg-white ${
                showNotification ? "translate-x-0 opacity-100" : "translate-x-full opacity-0"
              } `}
            >
              <CustomerEditTaskActivity
                taskid={taskid?.id}
                showNotification={showNotification}
                handleNotification={handleNotification}
                cross={cross}
              />
            </div>
          </FloatingList>
        )} */}
      </div>

      {isLinkOpen && (
        <LinkedDrawer
          open={isLinkOpen}
          data={initialFormData}
          onClose={() => setIsLinkOpen(false)}
          parentId={taskid}
          parentType="TASK"
          selectedCustomer
          subDrawer
        />
      )}

      {showNotification && (
        <CustomerEditTaskActivity
          activityid={taskid?.id}
          // showNotification={showNotification}
          // handleNotification={handleNotification}
          // cross={cross}
          open={showNotification}
          onClose={handleNotification}
          type="Task"
          // parallelDrawer
          subDrawer
        />
      )}

      {showSubtaskForm === "task" && (
        <SubTaskDrawer
          isEditTask={isEditTask}
          formData={formData}
          handleDeleteSubtask={handleDeleteSubtask}
          customerTaskCategory={customerCommonData}
          startDate={startDate}
          endDate={endDate}
          personTableData={personTableData}
          handleSubTaskPerson={handleSubTaskPerson}
          handleCheck={handleCheck}
          searchTerm={searchTerm}
          subTaskContainerRef={subTaskContainerRef}
          handleSubtaskChange={handleSubtaskChange}
          handleSubtaskCheckboxChange={handleSubtaskCheckboxChange}
          isFormDisabled={isFormDisabled}
          handleMouseEnter={handleMouseEnter}
          handleMouseLeave={handleMouseLeave}
          isSearchBarOpen={isSearchBarOpen}
          setIsSearchBarOpen={setIsSearchBarOpen}
          dropdownCoord={dropdownCoord}
          taskassignedtoref={taskassignedtoref}
          subTaskSelected={subTaskSelected}
          setSubtaskSelected={setSubtaskSelected}
          fetchPersonData={fetchPersonData}
          subTaskForm={subTaskForm}
          setSubTaskForm={setSubTaskForm}
          initialSubTaskForm={initialSubTaskForm}
          subDrawer
          open={showSubtaskForm === "task"}
          addSubtask={addSubtask}
          addChecklist={addChecklist}
          setFormData={setFormData}
          onClose={() => {
            setShowSubtaskForm(false);
          }}
        />
      )}

      {showSubtaskForm === "project" && (
        <ChecklistDrawer
          isEditTask={isEditTask}
          formData={formData}
          handleDeleteSubtask={handleDeleteSubtask}
          customerTaskCategory={customerCommonData}
          personTableData={personTableData}
          handleSubTaskPerson={handleSubTaskPerson}
          handleCheck={handleCheck}
          searchTerm={searchTerm}
          subTaskContainerRef={subTaskContainerRef}
          handleSubtaskChange={handleSubtaskChange}
          handleSubtaskCheckboxChange={handleSubtaskCheckboxChange}
          isFormDisabled={isFormDisabled}
          handleMouseEnter={handleMouseEnter}
          handleMouseLeave={handleMouseLeave}
          isSearchBarOpen={isSearchBarOpen}
          setIsSearchBarOpen={setIsSearchBarOpen}
          dropdownCoord={dropdownCoord}
          taskassignedtoref={taskassignedtoref}
          subTaskSelected={subTaskSelected}
          setSubtaskSelected={setSubtaskSelected}
          fetchPersonData={fetchPersonData}
          checklistForm={checklistForm}
          setChecklistForm={setChecklistForm}
          initialChecklistForm={initialChecklistForm}
          useLazyGetProjectTaskEnumQuery={useLazyGetProjectTaskEnumQuery}
          projectFieldListLoading={projectFieldListLoading}
          handleChecklistChange={handleChecklistChange}
          subDrawer
          open={showSubtaskForm === "project"}
          onClose={() => {
            setShowSubtaskForm(false);
          }}
          addSubtask={addSubtask}
          addChecklist={addChecklist}
          setFormData={setFormData}
        />
      )}

      {openConfirmationDialog && (
        <ConfirmationDialogBox
          open={openConfirmationDialog}
          // open={hasFormChanged && categoryChange?.name?.toLowerCase() === "category_id"}
          onClose={() => {
            checkAndPerformOperation("close_only_confirmation_dialog");
          }}
          onConfirm={() => {
            checkAndPerformOperation(openConfirmationDialog);
          }}
        >
          <div>
            {formData?.sub_tasks?.some((subtask) => subtask.subject !== "")
              ? "Changing the task category will remove all associated sub-tasks."
              : ""}
            {formData?.sub_tasks?.some((subtask) => subtask.subject !== "") && <br />}
            Do you want to discard the changes you have done.?
          </div>
        </ConfirmationDialogBox>
      )}
      {openAddNewPodModal && (
        <div>
          <AddNewPodModal
            open={openAddNewPodModal}
            onClose={() => setOpenAddNewPodModal(false)}
            taskid={taskid?.id}
            category_id={formData?.category_id}
            customerId={taskid?.customer_id || formData?.customer_id}
            refetchPods={refetchAllTaskpods}
          />
        </div>
      )}
      {openAddProject && (
        <AddViewProjectDrawer
          open={openAddProject}
          setOpen={setOpenAddProject}
          onClose={() => setOpenAddProject(false)}
          customerTaskPodAllCustomer={customerTaskPodAllCustomer}
          setJobFormData={setFormData}
          projectId={formData?.project_id}
          getFieldValue={getFieldValue}
          projectFieldList={projectFieldList}
          fetchPersonInTable={fetchPersonData}
          personTableData={personTableData}
          selectedCustomer={selectedCustomer || { id: formData?.customer_id }}
        />
      )}
    </CustomDrawer>
  );
};
export default AddTaskPodModal;
